define('view/controller/booking/datetime/slots/TimeSlotView',['require','lib/view/LayoutView','Config'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var Config = require('Config');
	
	/**
	 * Time slot item view (time slot item)
	 * 
	 * @class TimeSlotView
	 */
	return LayoutView.extend({
	
	    template: '#time_slot_view',
        
        ui: {
            'cell': '.sb-cell'
        },
        
        triggers: {
            'click @ui.cell': 'select:time'
        },

		serializeData: function () {
			var result = LayoutView.prototype.serializeData.apply(this);
			result.time_diff = this.getOption('clientTimeZone').get('time_diff');

			var timeframe = Config.getInstance().getOption('time_frame');

            var booking = this.getOption('bookingModel');
            
            var service = booking ? booking.get('service') : undefined;
            var duration = service ? service.duration : timeframe * result.slots_count; // default value to show until service loaded
            
            var products = booking ? booking.getProductsAddonsList() : undefined;
            products = products ? products.map(function (product) { return product.duration; }) : [];
            var productsDuration = _.reduce(products, function (a, b) { return +a + +b; }, 0);
            result.end_datetime = new Date(result.datetime);
            result.end_datetime.setTime(result.end_datetime.getTime() + (duration * 60 * 1000) + (productsDuration * 60 * 1000));

            var endTime = new Time(result.end_datetime);

            result.end_time = endTime.getFormattedTime('24hr');

			return result;
		}
	    
	});
	
});
